'use strict';

const { getBuyerUid, getLoggedInUserId } = require('../common/adformHelperFunctions');
const { getAdformConfig } = require('../common/jsConfig');

/**
 * Generate data we want to include in tracking urls for products (for click and in viewport).
 *
 * @param {Element} productTile - element we check
 * @param {Object} parsedBid - object holding info for this bid (url, price...)
 * @return {string} - updated url
 */
function generateTrackerExtraVars(productTile, parsedBid) {
    if (!productTile || !parsedBid) {
        return '';
    }

    const pid = productTile.getAttribute('data-pid') || '';
    const categoryId = parsedBid?.descriptionAsset?.category_ids[0] || '';
    const mappedBrandIdPrefix = getAdformConfig('adform_mapped_Brand_Id') || '';
    const rawBrandId = parsedBid?.descriptionAsset?.brand_id || '';
    const brandId = mappedBrandIdPrefix ? rawBrandId.replace(mappedBrandIdPrefix, '') : rawBrandId;
    const seriesIds = ''; // we are not using it, although it exists (bid.descriptionAsset.series_ids)
    const firstPartyId = getLoggedInUserId();
    const corId = getBuyerUid();
    const price = productTile.querySelector('.js-sales span')
        ?.getAttribute('content')
        ?.replace('.', ',');

    return `extvars=${pid}|${categoryId}|${brandId}|${seriesIds}|${firstPartyId}|${corId}|${price}`;
}

/**
 * Update url to include additional data (extra vars).
 *
 * @param {string} url - url string
 * @param {string} paramKey - param key (where to append data)
 * @param {string} extraVars - data we want to append
 * @return {string} - updated url
 */
function appendExtraVarsToUrl(url, paramKey, extraVars) {
    if (!url || !paramKey) {
        return '';
    }
    let updatedUrl = new URL(url);
    let param = updatedUrl.searchParams.get(paramKey);
    if (!param) {
        return '';
    }

    updatedUrl.searchParams.set(paramKey, `${param};${extraVars}`);

    // Note: URL.toString automatically encodes url => it leads to issues on adform side (can't get extra vars)
    return decodeURIComponent(updatedUrl.toString());
}

/**
 * Expand "product in viewport tracking url" with additional info.
 *
 * @param {Element} productTile - element we check
 * @param {Object} parsedBid - object holding info for this bid (url, price...)
 * @return {string} - updated tracking url
 */
function expandProductInViewportTrackingUrl(productTile, parsedBid) {
    const bidImpTrackerURL = parsedBid?.impTrackerURL;
    if (!productTile
        || !bidImpTrackerURL
    ) {
        return '';
    }

    const urlParamKey = 'rotseqno';
    const extraVars = generateTrackerExtraVars(productTile, parsedBid);
    if (!extraVars) {
        return '';
    }

    return appendExtraVarsToUrl(bidImpTrackerURL, urlParamKey, extraVars);
}

/**
 * Expand "product clicked tracking url" with additional info.
 *
 * @param {Element} productTile - element we check
 * @param {Object} parsedBid - object holding info for this bid (url, price...)
 * @return {string} - updated tracking url
 */
function expandProductClickedTrackingUrl(productTile, parsedBid) {
    const bidLinkUrl = parsedBid?.linkURL;
    if (!productTile
        || !bidLinkUrl
    ) {
        return '';
    }

    const urlParamKey = 'bn';
    const extraVars = generateTrackerExtraVars(productTile, parsedBid);
    if (!extraVars) {
        return '';
    }

    return appendExtraVarsToUrl(bidLinkUrl, urlParamKey, extraVars);
}

module.exports = {
    expandProductInViewportTrackingUrl: expandProductInViewportTrackingUrl,
    expandProductClickedTrackingUrl: expandProductClickedTrackingUrl
};
